<div *ngIf="!isEmpty" class="header">
    <div class="col-sm-7" style="padding: 0 15px;">
        <h2 *ngIf="contenant.id && parent != 'StockBacComponent'">
         Modification contenant </h2>
        <h2 *ngIf="!contenant.id && parent != 'StockBacComponent'">
         Création contenant
        </h2>
        
        <div *ngIf="parent == 'StockBacComponent'">
            <div class="form-group items col-sm-12 wrapcombocode">
              <label class="col-sm-4 champ" style="padding:0px"> Code contenant :</label>
              <div class="col-sm-8 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="changerComboCode($event);" [isCombo]="true"
                  [results]="comboCode" [highlight]="true" [label]="''" id="modedepaie typecontenants"
                  [selectvalue]="true" [placeholder]="''" [defaultselected]="comboCodeChoisi ? comboCodeChoisi.libelle : ''"
                  [defaultsearch]="comboCodeChoisi.libelle"
                  [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>            
              </div>
            </div>
        </div>
    </div>
    <div class="col-sm-5 text-right" style="padding-right: 0;">
        <button class="btn-header uppercase" id="log" *ngIf="contenant.id && contenant.id > 0" (click)="common.getLogs(contenant.id, '14', modalService);">
            Log </button>                
        <button class="btn-header uppercase" (click)="returnList()" id="close2">
          Fermer </button>
        <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
      Valider </button>
    </div>
</div>
<mat-divider *ngIf="!isEmpty"></mat-divider>
<div *ngIf="!isEmpty" class="paramsociete article">
  <ngb-tabset>
    <ngb-tab>
      <ng-template ngbTabTitle> Contenant </ng-template>
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 0;">
          <div class="group1" style="padding-top: 10px;">
            <!--div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Icône personnalisé : </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <mat-checkbox class="example-margin" color="primary" [(ngModel)]="contenant.regroupementPlanning"></mat-checkbox>
                  <input type="text" class="form-control" [(ngModel)]="contenant.numcontenant">
                </div>
              </div-->
            <!--Modification imposible: famille cont, cubage, unite -->
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Code contenant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="contenant.codeBD">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Type de contenant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="contenant.typeContenant = $event;" [isCombo]="true"
                  [results]="typeContenant" [highlight]="true" [label]="''" id="modedepaie typecontenants"
                  [selectvalue]="true" [placeholder]="''" [defaultselected]="contenant.typeContenant"
                  [defaultsearch]="contenant.typeContenant ? contenant.typeContenant.libelleObjetEntite : 'Tous'"
                  [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="societe.tareBenne">
              <label class="col-sm-3 champ" style="padding:0px"> Tare (Kg) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="contenant.tare">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Article contenu :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" (searchfunction)="searchArticleContenu($event)"
                  (selectfunction)="contenant.art = $event;" [notOblig]="true" [label]="''" [selectvalue]="true"
                  [results]="artContenu" [id]="'modedepaie artContenu'"
                  [defaultsearch]="contenant.art ? (contenant.art.libelle || contenant.art.libelleObjetEntite) : artContenu[0].libelleObjetEntite.libelleObjetEntite"
                  [autohide]="true" (keyenterfunction)="common.focusNext('.modalFicheClient');"
                  [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Fournisseur :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <!--
                <app-autocomplete [placeholder]="''" [highlight]="true" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.fournisseur = $event;" [defaultselected]="contenant.fournisseur"
                  [results]="listfournisseur"
                  [defaultsearch]="contenant.fournisseur ? (contenant.fournisseur.libelle || contenant.fournisseur.libelleObjetEntite) : ''">
                </app-autocomplete>-->
                <app-autocomplete (selectfunction)="contenant.fournisseur = $event;" [isCombo]="true"
                  [results]="listFournisseur" [highlight]="true" [label]="''" id="modedepaie typecontenants"
                  [selectvalue]="true" [placeholder]="''" [defaultselected]="contenant.fournisseur"
                  [defaultsearch]="contenant.fournisseur ? contenant.fournisseur.libelleObjetEntite : 'Aucun'"
                  [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>                
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date d'entrée dans le parc :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [class]="'form-control'" [id]="'date'" [model]="contenant.modelDebut"
                  (changefct)="contenant.modelDebut = $event; changeDateDebut($event, contenant); showDate = true"
                  [placeholder]="'Date debut'"
                  (keyenterfct)="common.changeDate($event, contenant.modelDebut, '#dateF');" [showDatepicker]="true" [closeDatepickerOnSelect]="true">
                </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Etat de reception du contenant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.etatReceptionBac = $event" [defaultselected]="contenant.etatReceptionBac"
                  [results]="listEtatRecepCont" [label]="''"
                  [defaultsearch]="contenant.etatReceptionBac ? (contenant.etatReceptionBac.libelle || contenant.etatReceptionBac.libelleObjetEntite) : ''"
                  id="input-site" [minlength]="1"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Coût du contenant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="contenant.cout">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Mode de préhension du bac :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.modePrehensionBac = $event"
                  [defaultselected]="contenant.modePrehensionBac" [results]="listModePrehension" [label]="''"
                  [defaultsearch]="contenant.modePrehensionBac ? (contenant.modePrehensionBac.libelle || contenant.modePrehensionBac.libelleObjetEntite) : ''"
                  id="input-site" [minlength]="1"></app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Couleur du couvercle :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.couleurCouvercleBac = $event"
                  [defaultselected]="contenant.couleurCouvercleBac" [results]="listCouleurCouvert" [label]="''"
                  [defaultsearch]="contenant.couleurCouvercleBac ? (contenant.couleurCouvercleBac.libelle || contenant.couleurCouvercleBac.libelleObjetEntite) : ''"
                  id="input-site" [minlength]="1"></app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Type de couvercle :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.typeCouvercleBac = $event"
                  [defaultselected]="contenant.typeCouvercleBac" [results]="listeTypeCouvercleBac" [label]="''"
                  [defaultsearch]="contenant.typeCouvercleBac ? (contenant.typeCouvercleBac.libelle || contenant.typeCouvercleBac.libelleObjetEntite) : 'Non renseigné'"
                  id="input-site" [minlength]="1"></app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Caractéristique du PAV :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.caracteristiquePAV = $event"
                  [defaultselected]="contenant.caracteristiquePAV" [results]="listecaracteristiquePAV" [label]="''"
                  [defaultsearch]="contenant.caracteristiquePAV ? contenant.caracteristiquePAV.libelleObjetEntite  : 'Non renseigné'"
                  id="input-site" ></app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Numero d'identification de la puce :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="texte" class="form-control" [(ngModel)]="contenant.numPuce">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Code barre associé :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="texte" class="form-control" [(ngModel)]="contenant.codeBarre">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Serrure :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="contenant.serrure"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> N° de clef :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="texte" class="form-control" [(ngModel)]="contenant.numClef" [disabled]="!contenant.serrure">
              </div>
            </div>            
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Localisation du contenant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" [isCombo]="true" id="input-site"
                  (selectfunction)="contenant.etatBac = $event" [defaultselected]="contenant.etatBac"
                  [results]="listLocalCont" [label]="''"
                  [defaultsearch]="contenant.etatBac ? (contenant.etatBac.libelle || contenant.etatBac.libelleObjetEntite) : ''"
                  id="input-site"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date de sortie du parc :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [class]="'form-control'" [id]="'dateF'" [dateVide] = "true" [model]="contenant.modelFin"
                  (changefct)="contenant.modelFin = $event; changeDateFin($event, contenant); showDate = true"
                  [placeholder]="'Date debut'"
                  (keyenterfct)="common.changeDate($event, contenant.modelFin, '#valeur'); " [showDatepicker]="true"
                  [position]="'top-left'" [closeDatepickerOnSelect]="true"></app-input-date>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
  </ngb-tabset>
</div>

<div class="col-sm-12" *ngIf="isEmpty" style="height: 100%; padding: 40px;background-color: #f9f9f9;">
  <div style="border: 5px solid #efefef; padding: 20px 20px 0; margin-bottom: 30px;">
    <div class="empty"></div>
    <div class="empty"></div>
  </div>

  <div style="border: 5px solid #efefef; padding: 20px 20px 20px 25px;">
    <img src="assets/images/emptytable.svg" />
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>

<ng-template #loadingSygetrack>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ nomInformatiqueImbrique }} </h4>
  </div>    
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px; text-align: justify" 
                  [innerHTML]="msgSygetrack ? msgSygetrack : 'Attente du retour de ' + nomInformatiqueImbrique"></label>
          </div>
      </div>
      
      <div class="text-right" style="margin-top: 15px;" *ngIf="msgSygetrack">
          <button type="button" class=" btn-close btn-valider" (click)="closeSygetrack()"> Fermer </button>
      </div>
  </div>
</ng-template>
